import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@s/Button';

class TicketsButton extends Component {
    getButtonText = () => {
        let buttonText = TicketsButton.defaultProps.title;

        if (!this.props.isRecurring && this.props.hasPresale && !this.props.isOnsale && Object.keys(this.props.priceLevels.levels).length === 0) {
            buttonText = "Enter presale code";
        } else if (this.props.uiConfig.listings && this.props.uiConfig.listings.buttonText) {
            buttonText = this.props.uiConfig.listings.buttonText;
        }

        if(this.props.title) {
            buttonText = this.props.title;
        }

        return buttonText;
    };

    getButtonType = () => {
        let buttonType = "";

        if(this.props.type) {
            buttonType = this.props.type;
        }

        return buttonType;
    }

    render() {
        if (this.props.isOnsale || (!this.props.isOnsale && this.props.hasPresale) || this.props.isRecurring) {
            return(
                <Button
                    onClick={ this.props.onClick }
                    className={`button--primary banner__cta ${this.getButtonType()} ${this.props.loading ? 'loading' : 'not-loading' }`}
                    loading={this.props.loading}
                    loadingText={this.getButtonText()}>
                        {this.getButtonText()}
                        {this.props.children}
                </Button>
            )
        } else {
            return(<span></span>)
        }
    }
}

TicketsButton.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    uiConfig: PropTypes.object,
    priceLevels: PropTypes.object,
    coupon: PropTypes.object,
    hasPresale: PropTypes.bool,
    isOnsale: PropTypes.bool,
};

TicketsButton.defaultProps = {
    title: "Get Tickets",
};

export default TicketsButton;
